import {request} from "@/backend/backend_util.ts";

export interface DocumentInfo {
    filename: string;
    name: string;
}

export interface DocumentContent {
    filename: string;
    content: string;
}

export interface DocumentList {
    documents: DocumentInfo[];
}

export const docsBackend = {
    // List all available documents
    listDocuments: request<DocumentList>('GET', '/docs'),
    
    // Get a specific document by filename
    getDocument: (filename: string) => request<DocumentContent>('GET', `/docs/${filename}`)(),
};
